import React from 'react';

type Props = {
  className?: string
};

const ContactsTable: React.FC<Props> = ({ children, className = '' }) => {
  return (
    <div className={`overflow-x-auto ${className}`}>
      <table className="table border mb-0">
        <thead>
          <tr className="bg-light font-weight-bold">
            <th>Name</th>
            <th>Email</th>
            <th>Phone</th>
            <th>Alt. Phone</th>
            <th>Best Time To Call</th>
            <th>Primary</th>
            <th>Edit</th>
            <th>Delete</th>
          </tr>
        </thead>

        <tbody>
          {children}
        </tbody>
      </table>
    </div>
  );
};

export default ContactsTable;
